import React, { useState } from "react";

import { ReactComponent as ArrowUpRightIcon } from "@assets/images/icons/arrow-up-green.svg";
import { ReactComponent as ArrowDownIcon } from "@assets/images/icons/arrow-down.svg";

import "./FollowersTab.sass";

// --- MOCK DATA ---
const initialFollowers = [
  {
    id: 1,
    user: "Use***5gd",
    balance: "1,936.79 USDT",
    pnl: "+1,936.79 USDT",
    roi: "+8.88%",
    duration: "16 Days",
  },
  {
    id: 2,
    user: "Use***99gd",
    balance: "1,366.79 USDT",
    pnl: "+934.79 USDT",
    roi: "+76.45%",
    duration: "63 Days",
  },
  {
    id: 3,
    user: "Use***romgd",
    balance: "1,366.77 USDT",
    pnl: "+1,936.79 USDT",
    roi: "+10.65%",
    duration: "15 Days",
  },
  {
    id: 4,
    user: "Use***54e0ogd",
    balance: "10,936.79 USDT",
    pnl: "+944.79 USDT",
    roi: "+188.66%",
    duration: "11 Days",
  },
  {
    id: 5,
    user: "Use***e4i9id",
    balance: "1,982.94 USDT",
    pnl: "+906.77 USDT",
    roi: "+8.88%",
    duration: "13 Days",
  },
  {
    id: 6,
    user: "Use***545n",
    balance: "1,306.79 USDT",
    pnl: "+906.79 USDT",
    roi: "+90.23%",
    duration: "11 Days",
  },
  {
    id: 7,
    user: "Use***xkm",
    balance: "796.79 USDT",
    pnl: "+636.79 USDT",
    roi: "+322.35%",
    duration: "13 Days",
  },
];

const SortIcon = ({ direction }) => (
  <div className="followers-table__sort-icon">
    <ArrowDownIcon
      className={`followers-table__sort-arrow followers-table__sort-arrow--up ${
        direction === "asc" ? "active" : ""
      }`}
    />

    <ArrowDownIcon
      className={`followers-table__sort-arrow followers-table__sort-arrow--down ${
        direction === "desc" ? "active" : ""
      }`}
    />
  </div>
);

export const FollowersTab = () => {
  const [data, setData] = useState(initialFollowers);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: null });

  const handleSort = (key) => {
    let direction = "asc";

    if (sortConfig.key === key) {
      if (sortConfig.direction === "asc") {
        direction = "desc";
      } else if (sortConfig.direction === "desc") {
        direction = null; // Third state: Turn off sorting
      }
    }

    if (!direction) {
      setData(initialFollowers);
      setSortConfig({ key: null, direction: null });
      return;
    }

    const sortedData = [...initialFollowers].sort((a, b) => {
      const valA = parseFloat(a[key].replace(/[^0-9.-]+/g, ""));
      const valB = parseFloat(b[key].replace(/[^0-9.-]+/g, ""));

      if (valA < valB) return direction === "asc" ? -1 : 1;
      if (valA > valB) return direction === "asc" ? 1 : -1;
      return 0;
    });

    setData(sortedData);
    setSortConfig({ key, direction });
  };

  const getSortDir = (key) =>
    sortConfig.key === key ? sortConfig.direction : null;

  return (
    <div className="followers-table-wrapper">
      <table className="followers-table">
        <thead>
          <tr>
            <th>User ID</th>
            <th
              onClick={() => handleSort("balance")}
              className="followers-table__sortable-th"
            >
              <div className="followers-table__flex-wrap">
                Copy Margin Balance
                <SortIcon direction={getSortDir("balance")} />
              </div>
            </th>
            <th
              onClick={() => handleSort("pnl")}
              className="followers-table__sortable-th"
            >
              <div className="followers-table__flex-wrap">
                Total PNL <SortIcon direction={getSortDir("pnl")} />
              </div>
            </th>
            <th
              onClick={() => handleSort("roi")}
              className="followers-table__sortable-th"
            >
              <div className="followers-table__flex-wrap">
                Total ROI <SortIcon direction={getSortDir("roi")} />
              </div>
            </th>
            <th
              onClick={() => handleSort("duration")}
              className="followers-table__sortable-th"
            >
              <div className="followers-table__flex-wrap">
                Duration <SortIcon direction={getSortDir("duration")} />
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          {data.map((item) => {
            const isPnlPositive = item.pnl.includes("+");
            const isRoiPositive = item.roi.includes("+");

            return (
              <tr key={item.id}>
                <td>{item.user}</td>
                <td>{item.balance}</td>
                <td
                  className={isPnlPositive ? "followers-table__text-green" : ""}
                >
                  {item.pnl}
                </td>
                <td
                  className={isRoiPositive ? "followers-table__text-green" : ""}
                >
                  <div className="followers-table__flex-wrap">
                    {item.roi} {isRoiPositive && <ArrowUpRightIcon />}
                  </div>
                </td>
                <td>{item.duration}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};
